import _intersection from "lodash/intersection";
/**
 * Set ui schema property with value form reference field
 * @param {String} params.field -
 * @param {String} params.dataField - source of data 
 * @param {String} params.uiProperty - proprty wich value is set
 */
export const StaticErrorIfArrayMatches = function (params: any, schema: any, uiSchema: any, formData: any) {
  const { field, compareTo, errorText } = params;

  if (_intersection(formData[field], formData[compareTo]).length >= 1) {
    uiSchema[field]["_StaticValidationError"] = errorText;
  } else {
    delete uiSchema[field]["_StaticValidationError"];
  };

};


// Action validation
if (process.env.NODE_ENV !== "production") {

  const PropTypes = require("prop-types");

  StaticErrorIfArrayMatches.propTypes = {
    field: PropTypes.string,
    dataField: PropTypes.string,
    uiProperty: PropTypes.string
  };

}